export const debouncePromise = (fn, wait) => {
  let timer;
  let pending;
  return (...args) => {
    if (timer) clearTimeout(timer);
    if (pending) pending.resolve([]);
    return new Promise((resolve, reject) => {
      pending = { resolve, reject };
      timer = setTimeout(() => {
        timer = null;
        const current = pending;
        pending = null;
        Promise.resolve(fn(...args)).then(current.resolve, current.reject);
      }, wait);
    });
  };
};
